export default "__VITE_ASSET__d8c3cd39__"